import { useState } from 'react';
import type { Hint } from '../sudoku';

interface HintPanelProps {
  hint: Hint;
  onPlace: (index: number, value: number) => void;
  onClose: () => void;
}

/** Teach-the-technique hint with progressive disclosure:
 *  nudge -> technique + explanation -> optional placement. */
export function HintPanel({ hint, onPlace, onClose }: HintPanelProps) {
  const [stage, setStage] = useState(0);

  return (
    <aside className="hint-panel" aria-live="polite">
      <div className="hint-head">
        <strong>Hint</strong>
        <button type="button" className="link" onClick={onClose} aria-label="Dismiss hint">
          ✕
        </button>
      </div>

      <p className="hint-nudge">{hint.nudge}</p>

      {stage === 0 && hint.technique !== 'Mistake' && (
        <button type="button" onClick={() => setStage(1)}>
          Show me the technique
        </button>
      )}

      {(stage >= 1 || hint.technique === 'Mistake') && (
        <div className="hint-detail">
          <p className="hint-technique">{hint.technique}</p>
          <p>{hint.explanation}</p>
          {hint.placement && stage >= 1 && (
            <button
              type="button"
              onClick={() => onPlace(hint.placement!.index, hint.placement!.value)}
            >
              Place {hint.placement.value}
            </button>
          )}
        </div>
      )}
    </aside>
  );
}
